import React from 'react';
import { motion } from 'framer-motion';

import { RESIDENT_SCREENS } from './registry.js';
import { ARTICLES, ArticleSheet, useSavedArticles } from './news-screen.js';
import { useBuilding, RESIDENT } from '../state/building.js';
import { Chip, useFlash, useModal } from '../ui/kit.js';

const EASE = [0.16, 1, 0.3, 1];

const rise = (delay) => ({
    initial: { opacity: 0, y: 22, filter: 'blur(8px)' },
    animate: { opacity: 1, y: 0, filter: 'blur(0px)' },
    transition: { duration: 0.9, delay, ease: EASE }
});

/* The welcome screen's tiles, in the deck's two resident groups. */
const GROUPS = [
    { label: 'Hospitality & amenities', from: 'Valet', to: 'Building News' },
    { label: 'Your home', from: 'Service Requests', to: 'Billing' }
].map(group => {
    const keys = RESIDENT_SCREENS.map(item => item.screen);
    return { ...group, items: RESIDENT_SCREENS.slice(keys.indexOf(group.from), keys.indexOf(group.to) + 1) };
});

/** The resting screen: what the display shows when nobody has touched it. */
function NothingSelected() {
    const { go } = useBuilding();
    const [flash, notify] = useFlash();
    const [saved, mark] = useSavedArticles(notify);
    const notice = useModal();

    /* The notice is the lobby renovation story, so tapping it opens that
       article rather than a second, shorter copy of it. */
    const lobby = ARTICLES.find(a => a.title === 'Lobby Renovations');
    const lobbySaved = saved[lobby.title] || {};

    return (
        <div className="welcome welcome--modules">
            <motion.h1 className="welcome__title" {...rise(0.05)}>
                Good to see you.
            </motion.h1>

            <motion.p className="welcome__lead" {...rise(0.14)}>
                Residence {RESIDENT.unit}. Book, request and register everything
                the building offers, or catch up on what is happening here.
            </motion.p>

            <motion.button
                type="button"
                className="welcome__notice welcome__notice--open"
                onClick={() => notice.open(lobby)}
                aria-haspopup="dialog"
                {...rise(0.22)}
            >
                <span className="welcome__dot" aria-hidden="true" />
                <span className="welcome__notice-main">
                    <span className="welcome__notice-label">Building notice</span>
                    <p>
                        Renovation of the lobby starts next Monday. Please expect
                        temporary closures and use the west wing entrance.
                    </p>
                    <span className="welcome__notice-foot">
                        <span className="act-more">Read the full notice</span>
                        {lobbySaved.remind && <Chip tone="ok">Reminder set</Chip>}
                    </span>
                </span>
            </motion.button>

            <div className="welcome__flash">{flash}</div>

            {GROUPS.map((group, gi) => (
                <motion.div className="tiles__group" key={group.label} {...rise(0.3 + gi * 0.08)}>
                    <span className="tiles__label">{group.label}</span>
                    <div className="tiles">
                        {group.items.map(({ screen, label, Icon }) => (
                            <button type="button" className="tile" key={screen} onClick={() => go(screen)}>
                                <Icon aria-hidden="true" />
                                {label}
                            </button>
                        ))}
                    </div>
                </motion.div>
            ))}

            <ArticleSheet
                item={notice.item}
                saved={lobbySaved}
                onClose={notice.close}
                onMark={mark}
                extra={
                    <button type="button" className="btn btn-outline-light" onClick={() => { notice.close(); go('Building News'); }}>
                        All building news
                    </button>
                }
            />
        </div>
    );
}

export default NothingSelected;
